// extracted by mini-css-extract-plugin
export const slideshow = "Slideshow-module--slideshow--KEGsu";
export const inlineVideoPlayerContainer = "Slideshow-module--inline-video-player-container--3Gtjn";
export const imageFitContain = "Slideshow-module--image-fit-contain--2cQy3";
export const slideshowFullscreen = "Slideshow-module--slideshow-fullscreen--o085i";
export const imageFitCover = "Slideshow-module--image-fit-cover--3l4n5";
export const imageCaption = "Slideshow-module--image-caption--3n7lr";
export const imageCaptionInside = "Slideshow-module--image-caption-inside--3eemN";
export const fluidHeight = "Slideshow-module--fluid-height--3NilE";
export const arrowButton = "Slideshow-module--arrow-button--3pyHk";
export const arrowButtonRight = "Slideshow-module--arrow-button-right--3rsz8";
export const arrowButtonLeft = "Slideshow-module--arrow-button-left--1E-Bv";
export const buttonFullscreen = "Slideshow-module--button-fullscreen--3qPwQ";
export const icon = "Slideshow-module--icon--Q9sov";
export const playVideoButton = "Slideshow-module--play-video-button--1AZIR";
export const slideshowVideoItem = "Slideshow-module--slideshow-video-item--2xOOY";
export const imageGalleryThumbnailInner = "Slideshow-module--image-gallery-thumbnail-inner--1WrwT";
export const videoIcon = "Slideshow-module--video-icon--3nnP-";
export const thumbnailVideoIcon = "Slideshow-module--thumbnail-video-icon--1mmf6";
export const variantGray = "Slideshow-module--variant-gray--MT9h0";
export const slideshowHideCaption = "Slideshow-module--slideshow-hide-caption--1-lfp";
export const slideshowHideNavigation = "Slideshow-module--slideshow-hide-navigation--74LMy";
export const fullscreenInlineVideoPlayer = "Slideshow-module--fullscreen-inline-video-player--11IVo";
export const buttonFullscreenClose = "Slideshow-module--button-fullscreen-close--dZcZd";